import { useState } from "react";
import KanbanBoard from "../components/Kanban/KanbanBoard";
import { Page } from "@iq/models";


function Kanban() {

  return (
    <Page>
      <KanbanBoard />
    </Page>
  );
}

export default Kanban;
